import React, { Fragment } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import Breadcrumb from '../common/breadcrumb';
import { userRequest } from '../../auth/requestMethods';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import Email from '@mui/icons-material/Email';
import { formatDate } from '../../helper/formatDate';

const Manage = ({ history }) => {
  const [pageData, setPageData] = React.useState({
    email: {
      id: '',
      status: '',
      email_type_id: '',
      description: '',
      from: '',
      to: '',
      reply_to: '',
      cc: '',
      bcc: '',
      subject: '',
      body: '',
      body_html: '',
      created_date_time: '',
      sent_by_user_id: '',
      sending_attempt_count: '',
      resent_count: '',
      sent_date_time: '',
      has_email_send_failed: '',
      email_type: '',
      user: '',
    },
    attachments: [],
    errorLogs: [],
  });

  React.useEffect(() => {
    let temp = window.location.pathname.split('/');

    userRequest()
      .get('/emails/retrieve/' + temp[3])
      .then(({ data }) => {
        setPageData({
          email: data.email,
          errorLogs: data.errorLogs,
          attachments: data.attachments,
        });
      })
      .catch(({ response }) => {
        console.log(response);
      });
  }, []);

  function resend() {
    const row = pageData.email;
    userRequest()
      .post('/emails/resend' + row.id, { email: row })
      .then(({ data }) => {
        // TODO: set has_email_send_failed to true
      })
      .catch(({ response }) => console.log(response));
  }

  return (
    <Fragment>
      <Breadcrumb icon={<Email />} title="View" parent="Emails" />
      <div className="card">
        <div className="card-body">
          <div className="container-fluid">
            <div className="form-group row align-items-center mb-3">
              <label className="col-sm-5 col-form-label">Email Type</label>
              <label className="col-sm-5 col-form-label">{pageData.email.email_type}</label>
            </div>
            <div className="form-group row align-items-center mb-3">
              <label className="col-sm-5 col-form-label">Description</label>
              <label className="col-sm-5 col-form-label">{pageData.email.description}</label>
            </div>
            <div className="form-group row align-items-center mb-3">
              <label className="col-sm-5 col-form-label">From</label>
              <label className="col-sm-5 col-form-label">{pageData.email.from}</label>
            </div>
            <div className="form-group row align-items-center mb-3">
              <label className="col-sm-5 col-form-label">Reply To</label>
              <label className="col-sm-5 col-form-label">{pageData.email.reply_to}</label>
            </div>
            <div className="form-group row align-items-center mb-3">
              <label className="col-sm-5 col-form-label">To</label>
              <label className="col-sm-5 col-form-label">{pageData.email.to}</label>
            </div>
            <div className="form-group row align-items-center mb-3">
              <label className="col-sm-5 col-form-label">CC</label>
              <label className="col-sm-5 col-form-label">{pageData.email.cc}</label>
            </div>
            <div className="form-group row align-items-center mb-3">
              <label className="col-sm-5 col-form-label">BCC</label>
              <label className="col-sm-5 col-form-label">{pageData.email.bcc}</label>
            </div>
            <div className="form-group row align-items-center mb-3">
              <label className="col-sm-5 col-form-label">Subject</label>
              <label className="col-sm-5 col-form-label">{pageData.email.subject}</label>
            </div>
          </div>
          <div className="container-fluid" style={{ border: '1px solid #dddddd', borderRadius: '8px' }}>
            <LabTabs html={pageData.email.body_html} />
          </div>
          <br />
          <div className="form-group row align-items-center mb-3">
            <label className="col-sm-5 col-form-label">Sent By</label>
            <label className="col-sm-5 col-form-label">{pageData.email.user}</label>
          </div>
          <div className="form-group row align-items-center mb-3">
            <label className="col-sm-5 col-form-label">Status</label>
            <label className="col-sm-5 col-form-label">{pageData.email.status}</label>
          </div>
          <div className="form-group row align-items-center mb-3">
            <label className="col-sm-5 col-form-label">Date / Time Sent</label>
            <label className="col-sm-5 col-form-label">
              <span>{formatDate(pageData.email.sent_date_time)}</span>
              <span className="mx-2">{new Date(pageData.email.sent_date_time).toLocaleTimeString()}</span>
            </label>
          </div>
          <div className="form-group row" style={{ maxWidth: 400 }}>
            <p>
              <b>Attachments</b>
            </p>
            <DataGrid autoHeight hideFooter loading={false} rows={pageData.attachments} columns={attachmentsColumns} />
            <div className="d-flex justify-content-between my-3">
              <label className="col-form-label">Send Retries</label>
              <label className="col-form-label">{pageData.email.resent_count}</label>
            </div>
          </div>
          <br />
          <div className="form-group row" style={{ maxWidth: 400 }}>
            <p>
              <b>Error Log</b>
            </p>
            <DataGrid autoHeight hideFooter loading={false} rows={pageData.errorLogs} columns={errorLogsColumns} />
          </div>
          <br />
          <div>
            {pageData.email.has_email_send_failed && (
              <button className="btn btn-primary me-1" onClick={resend} type="button">
                Resend
              </button>
            )}
          </div>
        </div>
      </div>
    </Fragment>
  );
};

const errorLogsColumns = [
  {
    field: 'attempt_date_time',
    headerName: 'Date / Time',
    flex: 1,
  },
  {
    field: 'error_description',
    headerName: 'Error',
    flex: 1,
  },
];

const attachmentsColumns = [
  {
    field: 'actions',
    headerName: '',
    headerAlign: 'center',
    flex: 1,
    renderCell: ({ row }) => {
      function downloadDoc() {
        userRequest()
          .get(`/documents/download/${row.document_id}`, { responseType: 'blob' })
          .then((response) => {
            const url = window.URL.createObjectURL(
              new Blob([response.data], { type: response.headers['content-type'] })
            );
            window.open(url, '_blank');
          })
          .catch((res) => console.log(res));
      }
      return (
        <div className="d-flex justify-content-between align-items-center" style={{ cursor: 'pointer' }}>
          <p onClick={downloadDoc} style={{ color: 'blue', fontSize: '14px', cursor: 'pointer' }}>
            download
          </p>
        </div>
      );
    },
  },
  {
    field: 'filename',
    headerName: 'Attachments',
    flex: 1,
  },
];

function LabTabs({ html }) {
  console.log(html);
  const [value, setValue] = React.useState('1');

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%', typography: 'body1' }}>
      <TabContext value={value}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <TabList onChange={handleChange} aria-label="lab API tabs example">
            <Tab label="TEXT" value="1" />
            <Tab label="HTML" value="2" />
          </TabList>
        </Box>
        <TabPanel value="1">{html}</TabPanel>
        <TabPanel value="2">
          <div dangerouslySetInnerHTML={{ __html: html }} />
        </TabPanel>
      </TabContext>
    </Box>
  );
}

export default Manage;
